import styled from "styled-components";

type CropContainerProps = {
  $aspect: number;
};

export const CropContainer = styled.div<CropContainerProps>`
  position: relative;
  padding-bottom: ${props => (props.$aspect === 4 / 3 ? "50%" : "100%")};
`;

export const AdvancedCropContainer = styled.div`
  height: min(56vh, 420px);
  min-height: 300px;
  overflow: hidden;
  background: var(--color-neutral-darkness);

  .advanced-image-cropper {
    height: 100%;
    background: var(--color-neutral-darkness);
  }

  .keepo-crop-handler {
    width: 14px;
    height: 14px;
    background: var(--color-neutral-white);
    border: 2px solid #57f28b;
  }

  .keepo-crop-line {
    border-color: var(--color-neutral-white);
  }
`;

/* The zoom, on the footer's left */
export const ZoomControl = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  min-width: 0;
  padding-left: 0.5rem;
`;
